<div class="success-wrapper">

  <!-- Close icon -->
  <button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="content">
    <h1 class="title">
      Welcome to
     <img src="assets/alyn360.svg" style="width: 237px;">
    </h1>

    <p class="subtitle">Your journey starts here!</p>
<div class="goto-buttons">
  <button class="continue-btn1" (click)="goVendor()">
    Vendorpage
  </button>

  <button class="continue-btn2" (click)="goHome()">
    Back to Homepage
  </button>
</div>

  </div>

</div>
